module.exports = __webpack_public_path__ + "img/impostor-silhouete-bg-4.82a7d49b.png";